<template>
<div class="wallet" dir="rtl">
  <div class="page-title">کیف پول</div>
  <div class="depsoits-section">
     <div class="depsoit-headbar">
       <div class="headbar-label">ارزش کل دارایی شما</div>
       <div class="total-values">
         <span class="total-change" :class="{positive:totalProfit>0,negative:totalProfit<0}" dir="ltr"><span v-if="totalProfit>0">+</span>{{totalProfit}}%</span>
         <span class="total-depsoit" >{{ $toLocal(tomancash,$decimal['TOMAN']) }} </span>
         <span class="toman-tag">(تومان)</span>
       </div>
       <div class="btns ">
         <button v-for="(toman , index) in tomanBTN" :key="index" @click="OpenModal(index,$toLocal(wallets[0][1].credit))" class="depositeWith-btn" :class=toman.class>
                {{toman.title}}
            </button>
       </div>
     </div>
    <div class="switch-comp outer-filter-switch" :style="{maxWidth:'214px'}">
      <button class="switch-comp-button" :class="{'active-opt':depsoitsCurrencyType==='Crypto' }" @click="depsoitsCurrencyType='Crypto'">رمزارز</button>
      <button class="switch-comp-button" :class="{'active-opt':depsoitsCurrencyType==='Gold' }" @click="depsoitsCurrencyType='Gold'">طلا و سکه</button>
    </div>
    <div class="depsoit-table">
      <div class="depsoit-table-header">

        <div>کیف پول</div>
        <div>موجودی من</div>
        <div class="resp-2">معادل(تومان)</div>
        <div class="resp-1">تغییرات(24h)</div>
        <div class="action">
          <span>عملیات</span>
          <div class="switch-comp inner-filter-switch" :style="{maxWidth:'214px'}">
            <button class="switch-comp-button" :class="{'active-opt':depsoitsCurrencyType==='Crypto' }" @click="depsoitsCurrencyType='Crypto'">رمزارز</button>
            <button class="switch-comp-button" :class="{'active-opt':depsoitsCurrencyType==='Gold' }" @click="depsoitsCurrencyType='Gold'">طلا و سکه</button>
          </div>
        </div>

      </div>

      <div class="depsoit-table-row"  v-for="(coin,index) in (depsoitsCurrencyType==='Crypto')?wallets.filter(coins=> coins[0] !== 'TOMAN'):goldCoins" :key="index">



        <div class="coin-img-title">
          <!-- <img   class="resp-2" :src="'../../../../assets/coins'+  + '.png' "   :alt="coin[0]" /> -->
<!--          <img class="resp-2" :src="'/coins/'+coin[0]+ '.png'" alt="" width="28px">-->
          <img class="resp-2" :src="require('@/assets/coins/' + coin[0] + '.png')" alt="" width="28px" height="28px">


          <div class="coin-symbol-title">
          
            <div class="coin-title"> {{$coins[coin[0]].persianName }}</div>
            <div class="coin-symbol"> {{$coins[coin[0]].code}}</div>
          </div>
        </div>
        <div>{{$toLocal(coin[1].credit,0)}}</div>
        <div class="resp-2">{{$toLocal(coin[1].wholePriceOfCredit,2) }}</div>
        <div> % 0</div>
        <!-- <div dir="ltr"  class="resp-1" :class="{change:true,positive:coin.change>0,negative:coin.change<0}"><span v-if="coin.change>0">+</span>{{coin.change}}%</div> -->
        <div class="btns">
          <button class="btn depsoit-btn" @click="openDepModal([coin[0], credit(coin[1])] , index)">واریز</button>
          <button class="btn withdraw-btn" @click="openWithModal([coin[0], credit(coin[1])] , index)" >برداشت</button>
        
          <button class="btn trade-btn" @click="$router.push('/trade/TOMAN/'+ coin[0])">trade</button>
        </div>
      </div>

    </div>
  </div>

  <TransactionsTable/>


  <RialDepsoit v-if="modal==='DepositeToman'" @closeModal="closeModal"  :role="role"/>
  <RialWithdraw v-if="modal==='WidthdrawalToman'" @closeModal="closeModal" :cash="tomancash" @two-fa="openTwoStepModal" :role="role"/>
  <CryptoWithdraw :related-coin="relatedCoinVar" :cash="cash" :role="role" :wage="wage" v-if="modal==='WithdrawalBit'" @closeModaleEmit="modal=''" @two-fa="openTwoStepModal" :nets="nets" :exchange='false'/>
  <CryptoDepsoit v-if="modal==='DepositBit'" @closeModaleEmit="closeModal" :related-coin="relatedCoinVar" :cash="cash" @two-fa="openTwoStepModal" :wage="wage" :nets="nets" :exchange='false'/>

  <div class="history-link" @click="$router.push('/panel/history')">
    مشاهده همه تاریخچه
    <img src="../../../../assets/icon/left-arrow.svg"/>
  </div>


</div>

</template>

<script>
import TransactionsTable from "@/views/panel/components/Wallet/TransactionsTable";
import RialDepsoit from '../../../tools/Modals/RialDepsoit'
import CryptoDepsoit from '../../../tools/Modals/CryptoDepsoit'
import CryptoWithdraw from '../../../tools/Modals/CryptoWithdraw'
import RialWithdraw from '../../../tools/Modals/RialWithdraw'
export default {
  name: "wallet",
  components:{
    TransactionsTable,RialDepsoit ,CryptoDepsoit ,CryptoWithdraw, RialWithdraw
  },
  data(){
    return{



      
      totalProfit:2,
      totalDepsoit:10306632,
      coinIndex:null,
      coins:[
        {title:'بیتکوین',symbol:'BTC',depsoit:0.03,value:8437573,change:3.2},
        {title:'بیتکوین کش',symbol:'BCH',depsoit:0.03,value:8437573,change:3.2},
        {title:'اتریوم',symbol:'ETH',depsoit:0.03,value:8437573,change:3.2},
        {title:'ریپل',symbol:'XPR',depsoit:0.03,value:8437573,change:3.2},
        {title:'ترون ',symbol:'TRON',depsoit:0.03,value:8437573,change:-3.2}
      ],
      goldCoins:[
        {title:'تمام سکه',symbol:'tamam',credit:0.03,wholePriceOfCredit:8437573,change:3.2},
        {title:'نیم سکه',symbol:'nim',credit:0.03,wholePriceOfCredit:8437573,change:3.2},
        {title:'ربع سکه',symbol:'rob',credit:0.03,wholePriceOfCredit:8437573,change:3.2},
        {title:'مثقال',symbol:'mesghal',credit:0.03,wholePriceOfCredit:8437573,change:3.2},
      ],
      modalType:"",
      depsoitsCurrencyType:'Crypto',
      //Crypto,Rial,Gold
      transactionsCurrencyType:'Crypto',
      transactionsType:'WITHDRAW',
        showWithModal: false,
            showDepModal: false,
            showRWithModal: false,
            showRDepModal: false,
            wallets: [],
                   tomanBTN: [{
                    title: "واریز",
                    class: "btn depsoit-btn",
                    open: 'DepositeToman'
                },
                {
                    title: "برداشت",
                    class: "btn withdraw-btn",
                    open: 'WidthdrawalToman'
                }
            ],
            relatedCoinVar: '',
            cash: 0,
            tomancash:2,
            toman:'',
            twoStep: '',
            precent:[],
            transaction: {},
            // coins: [],
            wage: 0,
            role: {},
            loading: false,
            modal: ''

    }
  },
      computed: {
        amount() {
            return e => this.$toLocal(e.credit) || '0'
        },
        price() {
            return e => this.$toLocal(e[0] === 'TOMAN' ? e[1].totalBalance : e[1].wholePriceOfCredit, 0) || '0'
        },
        blocked() {
            return e => this.$toLocal(e[1].blockedCredit) || '0'
        },
        credit() {
            return e => this.$toLocal(e.credit) || '0'
        },
    },

    methods: {
      passData(){
        this.$emit('passRole', this.role)
        this.$emit('passToman', this.tomancash)
      },

        OpenModal(index,cash) {
            this.cash = cash
            this.wage = this.coins.find((a) => a.coin === "TOMAN").withdrawalFee
             this.role = this.coins.find((a) => a.coin === "TOMAN")
            this.modal = this.tomanBTN[index].open
        },
        OpenModalBit(e, index) {
            this.modal = this.buttons[index].open
            this.relatedCoinVar = e
            this.cash = e[1]
            this.wage = this.coins.find((a) => a.coin === e[0]).withdrawalFee
            this.role = this.coins.find((a) => a.coin === e[0])
        },
        openWithModal(e) {

            this.nets = this.coins.find((a) => a.coin === e[0]).tokenTypeDetails
            this.relatedCoinVar = e[0]
            this.cash = e[1]
            this.wage = this.coins.find((a) => a.coin === e[0]).withdrawalFee
            this.role = this.coins.find((a) => a.coin === e[0])
            this.modal = 'WithdrawalBit'
            // console.log('role',this.role)

        },
        openDepModal(e) {
// console.log(e)
            this.relatedCoinVar = e
            // this.cash = e[1]
            // this.wage = this.coins.find((a) => a.coin === e[0]).transferFee
            this.modal = 'DepositBit'
            this.nets = this.coins.find((a) => a.coin === e[0]).tokenTypeDetails
        },
        closeModal() {
            this.modal = ''
            // console.log('hi')
        },
        depositModal(e) {
            this.relatedCoinVar = e
            if (e[0] !== 'TOMAN') {
                this.showDepModal = true
            } else {
                this.showRDepModal = true
            }
        },
        withdrawModal(e) {
            this.relatedCoinVar = e[0]
            this.cash = e[1]
            this.wage = this.coins.find((a) => a.coin === e[0]).withdrawalFee
            if (e[0] !== 'TOMAN') {
                this.showWithModal = true
            } else {
                this.showRWithModal = true
            }
        },
        openTwoStepModal(e) {
            this.transaction = e[0]
            this.twoStep = e[1]
        },
        closemodal() {
            this.showWithModal = false
            this.showDepModal = false
            this.showRWithModal = false
            this.showRDepModal = false
            this.twoStep = ''
        },
        async getWallets() {
            this.state.loading = true
            // const coinsList="ETHEREUM,BITCOIN_CASH,TRON,RIPPLE,TETHER,TOMAN,BITCOIN"
            this.loading = true
            const [res, ] = await this.$http.get('/wallets/customer-addresses?walletType=P2P')
            
            if (res) {
                let entireRes = Object.entries(res)
                const sortCoins = this.$walletSortCoins
                entireRes.sort((a, b) => sortCoins.indexOf(a[0]) - sortCoins.indexOf(b[0]))
                     this.toman=entireRes[0]
                 entireRes = entireRes
                    // console.log(entireRes)
               
                this.wallets = entireRes
                 this.tomancash = res["TOMAN"].credit
                 this.toman = res['TOMAN']
                
                
            }
            this.loading = false

        },
        async submitWithdrawRequest(code) {
            this.state.loading = true
            this.transaction.code = code
            const [res, ] = await this.$http.post(`/wallets/withdrawal-request`, this.transaction)
            if (res) {
                this.$error('درخواست شما با موفقیت ثبت شد', '', 'success')
                    ++this.state.requestChanged
                this.closemodal()
            }
        },
        async getData() {
            this.state.loading = true
            const res = await this.$axios.get('/coins/details')
            this.coins = res.content

        },
        async checkWallet(e) {
            let query = {
                relatedCoin: e
            }
            if (e === 'TETHER') {
                const res = await this.$error('', 'شبکه مورد نظر را انتخاب کنید', 'info', 'اتریومی', 'ترونی')
                if (res.dismiss !== 'backdrop') {
                    query.tokenType = res.isConfirmed ? 'ERC20' : 'TRC20'
                } else {
                    return;
                }
            }
            if (this.$etcChannelCoin.includes(e)) {
                query.txid = await prompt('TxId : شناسه تراکنش')
                if (!query.txid) {
                    return;
                }
            }
            this.state.loading = true
            const res = await this.$axios.get('/wallets/check-confirmed-transaction', {
                params: query
            })
            let text
            if (res.baseDTO.amount) {
                ++this.state.requestChanged
                text = `مقدار ${this.$toLocal(res.baseDTO.amount) || 0} ${this.$coinLabel[e]} واریز شده و تایید ${res.baseDTO.transactionIsDone ? 'شده' : 'نشده'}`
            } else {
                text = 'مقدار واریزی شناسایی نشد'
            }
            this.$error('', text, res.baseDTO.transactionIsDone ? 'success' : 'info')
        },
        goto(e) {
            this.$router.push('/profile/trade/' + 'TOMAN' + `/${e}`)
        },
    },
   async mounted() {
        this.state.loading = true
        await this.getWallets()
        await this.getData()
        // console.log(this.toman);
       await this.passData()
       
    },
}
</script>

<style scoped>
.history-link{
  display: flex;
  align-items: center;
  column-gap: 8px;
  color: #1199FA;
  cursor: pointer;
  font-size: clamp(14px,1.5vw,16px);
  text-align: left;
  justify-content: flex-end;
}
.wallet{
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  justify-content: flex-start;
  text-align:right;
}

.page-title{
  font-size: clamp(18px,2vw,24px);
  color: #ffffff;

}

.action{
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
  row-gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}
.depsoits-section{
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: clamp(15px,2.5vw,40px) clamp(15px,2.5vw,40px) clamp(15px,2vw,30px) clamp(15px,2vw,30px);
  flex-grow: 1;
}
.active-opt{
  background: rgba(215, 200, 200, 0.12)!important;
  color: rgba(17, 153, 250, 1)!important;
}
.switch-comp{
  display: flex;
  align-items: center;
  column-gap: 7px;
  flex-wrap: wrap;
  flex-grow: 1;
}
.switch-comp-button{
   background: transparent;
   color: rgba(215, 200, 200, 1);
   border-radius: 4px;
   border: 0.5px solid rgba(215, 200, 200, 0.35);
   cursor: pointer;
  white-space: nowrap;
  font-size: clamp(10px , 1.1vw , 12px);
   height:25px;
   flex-grow: 1;
}
.depsoit-table{
  margin-top: 60px;
  display: flex;
  flex-direction: column;
      overflow: scroll;
    position: relative;
        max-height: 666px;
}
.depsoit-table-header{
  position: sticky;
  top: 0;
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  height: 80px;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 1fr 2fr;
  font-size: clamp(12px,1.3vw,14px);
  color: #D7C8C8;
  column-gap: 8px;
  flex-grow: 1;
  font-weight: bold;
  margin-bottom: 27px;

}
.depsoit-table-row{
  display: grid;
  flex-grow: 1;
  column-gap: 8px;

  margin-top: 12px;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 1fr 2fr;
  font-size: clamp(12px,1.3vw,14px);
  min-height: 52px;
  color: #D7C8C8;


}

.change{
  font-size: clamp(12px,1.3vw,14px);
}
.positive{
  color: #04B3A2;
}
.negative{
  color: #D94F68;
}
.coin-img-title{
  display: flex;
  column-gap: 8px;
  align-items: center;
  color: #D7C8C8;
}

.coin-title{
  font-size: clamp(12px,1.3vw,14px);
}
.coin-symbol{
  font-size: clamp(9px,1.1vw,10px);

}

/*btns*/

.btn{
  flex-grow: 1;
  max-width:120px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;
}

.btns{
  display: flex;
  align-items: center;
  column-gap: 12px;
  row-gap: 6px;
  flex-wrap: wrap;
}
.depsoit-btn{
  color: #04B3A2;
  border: 1px solid #04B3A2;
  font-size: clamp(11px,1.1vw,12px);
}

.withdraw-btn{
  color: #D94F68;
  border:1px solid #D94F68;
  font-size: clamp(11px,1.1vw,12px);

}

.trade-btn{
  background: linear-gradient(181.54deg, #1199FA 1.31%, #123249 180.79%);
  color: white;
}
.depsoit-headbar{
  display: grid;
  align-items: center;
  row-gap: 8px;
  column-gap: 8px;
  grid-template-columns: 1fr 1fr 1fr;


}
.headbar-label{
  font-size: clamp(14px,1.5vw,16px);
  color: #FFFFFF;
}

.total-values{
  display: flex;
  align-items:center;
  column-gap: 5px;
}
.total-change{
  font-size: clamp(13px,1.3vw,14px);
  color: #04B3A2;
}

.total-depsoit{
  color: #FFFFFF;
  font-size: clamp(18px,2vw,23px);

}
.toman-tag{
  font-size: clamp(13px,1.3vw,14px);
  color: #D7C8C8;
}
.transactions-section{
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(40px);
  border-radius: 20px;
  padding: clamp(15px,2.5vw,40px) clamp(15px,2.5vw,40px) clamp(15px,2vw,30px) clamp(15px,2vw,30px);
  flex-grow: 1;
}
.outer-filter-switch{
  display: none;
  margin-top:20px
}

@media(max-width:1200px){
  .depsoit-table-row{
    min-height: 130px;
  }

  .resp-1{
    display: none;
  }
  .depsoit-table-header{
    grid-template-columns: 1fr 1fr 1fr 2fr;
  }
  .depsoit-table-row{
    grid-template-columns: 1fr 1fr 1fr 2fr;
  }
}
@media(max-width:900px){
  .depsoit-table-row{
    min-height: 170px;
  }
  .resp-2{
    display: none;
  }

  .depsoit-table-header{
    grid-template-columns:  1fr 1fr 2fr;
  }
  .depsoit-table-row{
    grid-template-columns:  1fr 1fr 2fr;
  }
}

@media(max-width:730px){

  .resp-3{
    display: none;
  }
  .depsoit-headbar{
    grid-template-columns: 1fr 1fr;
  }
}
@media(max-width:430px){

  .depsoit-headbar{
    grid-template-columns: 1fr ;
  }
  .inner-filter-switch{
    display: none;
  }
  .outer-filter-switch{
    display: flex;
  }
}

</style>